import styled from "styled-components";

export const Container = styled.div`
  /* width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;  */
`

export const Content = styled.div`
  max-width: 1200px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20;
  margin: 40px auto;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ContentGraphs = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 80px auto;
  max-width: 1200px;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
  `